/*
 * @Author: ningbo.kang
 * @Date: 2020-11-17 14:49:22
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-07-10 13:59:30
 * @Description: 描述 en-us语言包
 */
export default {
  wg: {
    required: '{0} field Required',
    invalidType: 'invalid data format',
    sn: 'Serial number',
    searchKey: 'Please input keyword',
    select: 'Please select',
    treeSelectPlaceholder: 'Please input keywords to search',
    inputPlaceholder: 'Please input ...',
    createAt: 'created at',
    searchproname: 'Support fuzzy search by process theme or process name',
    selectFlow: 'Please select associated processes',
    drafter: 'Initiator: ',
    drafterDept: 'Initiating Department: ',
    bt: {
      filter: 'Filter Condition',
      query: 'Query',
      reset: 'Reset',
      delete: 'Delete',
      operation: 'operation',
      confirm: 'OK',
      cancel: 'Cancel',
      addLinks: 'Add associated flow',
    },
    file: {
      bt: 'click upload',
      preview: 'preview',
      download: 'download',
      upload: 'upload',
      unupload: 'Not uploaded',
      msg: 'Only upload image type jpg,png,gif',
    },
    status: {
      running: 'Approving',
      end: 'Archived',
      back: 'Rejected',
      revoke: 'Cancelled',
      manualend: 'Abandoned',
    },
    table: {
      add: 'Add',
      delete: 'Delete',
      batchDel: 'Batch delete',
      confirm: 'Are you sure you want to batch delete?',
      confirmRow: 'Are you sure you want to delete this row of data',
      table: 'table',
      panel: 'panel',
      tableTip: 'Switch table display mode',
      panleTip: 'Switch panel display mode',
      import: 'Import',
      upload: 'Template download',
    },
  },
};
